import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ViewSimilar.css";
import { Box } from "@mui/material";

const ViewSimilar = ({ products }) => {
  const productRef = React.useRef(null);
  const navigate = useNavigate();
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const scrollLeft = () => {
    const width = productRef.current.offsetWidth;
    setScrollPosition((prev) => Math.max(prev - width - 20, 0));
  };

  const scrollRight = () => {
    const width = productRef.current.offsetWidth;
    const maxScroll =
      productRef.current.scrollWidth - productRef.current.clientWidth;
    setScrollPosition((prev) => Math.min(prev + width + 20, maxScroll));
  };

  const handleProductClick = (productId) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/product/${productId}`);
  };  

  return (
    <div className="container" style={{padding: "60px 0"}}>
      <h2 className="section-headings">Similar Products</h2>

      {isMobile ? (
        <Box className="similar-grid-container">
          <Box
            className="similar-grid"
            sx={{
              transform: `translateX(-${scrollPosition}px)`,
              transition: "transform 0.3s ease",
            }}
          >
            {products.map((product) => (
              <div
                className="similar-item"
                key={product.id}
                ref={productRef}
                onClick={() => handleProductClick(product.id)}
              >
                <img
                  src={`https://tarunika.backendapihub.com/images/${product.medianame}`}
                  alt={product.product_name}
                />
                <div className="product-details">
                  <p className="view-product-name" title={product.product_name}>
                    {product.product_name}
                  </p>
                  <p className="view-product-price">
                    Rs. {product.price.toFixed(2)}
                  </p>
                </div>
              </div>
            ))}
          </Box>
        </Box>
      ) : (
        <div className="similar-grid-wrap">
          {products.map((product) => (
            <div
              className="similar-item"
              key={product.id}
              ref={productRef}
              onClick={() => handleProductClick(product.id)}
            >
              <img
                src={`https://tarunika.backendapihub.com/images/${product.medianame}`}
                alt={product.product_name}
              />
              <div className="product-details">
                <p className="view-product-name" title={product.product_name}>
                  {product.product_name}
                </p>
                <p className="view-product-price">
                  Rs. {product.price.toFixed(2)}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ViewSimilar;
